import { gql } from '@apollo/client';

export const sendGeneralTransferDetailsToEmail = gql`
  mutation sendGeneralTransferDetails($id: String!, $input: GeneralTransferDetailsInput!) {
    sendGeneralTransferDetails(id: $id, input: $input)
  }
`;
